export default function ({ store, redirect }) {
    if (store.state.admin.auth.token) {
        return redirect('/admin')
    }
}
